import axios from 'axios'
import qs from 'qs'

const Axios = axios.create({
	
	// baseURL: process.env.VUE_APP_baseURL,
	// baseURL:'https://www.qx1024.com/zdy/api/pc/',
	baseURL:'https://www.zhidingcloud.com/zdy/api/pc/',
  tiemout: 20 * 1000,
});

// Axios.defaults.headers.post['Content-Type'] = 'application/x-www-from-urlencoded';

Axios.interceptors.request.use(
	config => {
	    // config.headers['Token'] = '';

	    // Post 请求使用 Query String 模式
	    if (!config.json&&config.method.toUpperCase() === 'POST') config.data = qs.stringify(config.data);

	    return config;
	},
	error => console.error(error)
);

Axios.interceptors.response.use(
	response => response.data,
	error => console.error(error)
);

export default Axios;